import { createSlice } from "@reduxjs/toolkit";


const workspacesSlice = createSlice({
    name: 'workspaces',
    initialState: {
        myWorkspaces: undefined,
        recommendedWorkspaces: undefined,
        workspaceOverview: undefined,
        workspaceChat: undefined,
        workspaceDocuments: undefined,
        workspaceReports: undefined,
        inProgress: false,
        errorMessage: undefined,
        dialogDetails: undefined,
        workspaceReportPreview: undefined,
        workspaceReportSaved: false,
        contentForCurrentSlideInReport: undefined,  
    },
    reducers: {
        setMyWorkSapcesData: (state: any, action: any) => {
            state.myWorkspaces = action.payload;
            return;
        },
        setRecommendedWorkSapcesData: (state: any, action: any) => {
            state.recommendedWorkspaces = action.payload;
            return;
        },
        setWorkspaceOverviewData: (state: any, action: any) => {
            state.workspaceOverview = action.payload;
            return;
        },
        setWorkspaceChatData: (state: any, action: any) => {
            state.workspaceChat = action.payload;
            return;
        },
        setWorkspaceDocuments: (state: any, action: any) => {
            state.workspaceDocuments = action.payload;
            return;
        },
        setWorkspaceReports: (state: any, action: any) => {
            state.workspaceReports = action.payload;
            return;
        },
        setErrorMessage: (state: any, payload: any) => {
            state.errorMessage = payload;
        },
        setProgress: (state: any, action: any) => {
            state.inProgress = action.payload;
        },
        setDialogDetails: (state: any, action: any) => {
            state.dialogDetails = action.payload;
        },
        setWorkspacePreviewDocument: (state: any, action: any) => {
            state.workspaceReportPreview = action.payload;
        },
        setContentForCurrentSlideInReport: (state: any, action: any) => {
            state.contentForCurrentSlideInReport = action.payload;
        }
    }
})

export const {
    setMyWorkSapcesData,
    setRecommendedWorkSapcesData,
    setWorkspaceOverviewData,
    setWorkspaceChatData,
    setWorkspaceDocuments,
    setWorkspaceReports,
    setProgress,
    setDialogDetails,
    setWorkspacePreviewDocument,
    setContentForCurrentSlideInReport
} = workspacesSlice.actions
export default workspacesSlice.reducer;